import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
// const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const NoHomologados = Loadable(lazy(() => import('views/pages/homologaciones/NoHomologados')));
const Homologados = Loadable(lazy(() => import('views/pages/homologaciones/Homologados')));

// const MaestroPrecioZona = Loadable(lazy(() => import('views/pages/maestro/MaestroPrecioZona')));
// const MaestroProductos = Loadable(lazy(() => import('views/pages/maestro/MaestroProductos')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: 'homologados',
            element: <Homologados />
        },
        {
            path: 'nohomologados',
            element: <NoHomologados />
        },
    ]
};

export default MainRoutes;
